import { useState } from 'react';

export const useToggleState = (initialState = false): [boolean, () => void] => {
  const [state, setState] = useState(initialState);
  return [state, () => setState((currentState: boolean) => !currentState)];
};
